// extracted by mini-css-extract-plugin
module.exports = {"createUser":"createUser_createUser__2VjoE"};